import React, { useEffect, useState } from 'react'
import { Spinner } from '@/components/spinner';
import { Step1 } from './Step1';
import { cleanWizardData, WizardData } from './Model';
import { useWizard, WizardProvider } from '@/common/wizard/wizard';
import { Result } from './Result';
import { useParams } from 'react-router-dom';
import { MainPageLayout } from '@/components/layout/MainLayout';
import { useAppContext } from '@/context/app';
import { BackButton } from '@/components/layout/NavBar';
import { MachinePath } from '../../Common';
import { Machine } from '@/services/model/machine';
import { MachineName } from '@/components/machine';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { Step4 } from './Step4';
import { Step5 } from './Step5';
import { Step6 } from './Step6';

const maxStep = 7

export const MachineChecklistWizardBody = ({ onDone, machine }: {
  onDone: (id: string) => void
  machine: Machine
}) => {
  // const {services, session, translates} = useAppContext()
  const { step } = useWizard()

  if (step === 0) {
    return <Step1 machine={machine} />
  } else if (step === 1) {
    return <Step2 machine={machine} />
  } else if (step === 2) {
    return <Step3 machine={machine} />
  } else if (step === 3) {
    return <Step4 machine={machine} />
  } else if (step === 4) {
    return <Step5 machine={machine} />
  } else if (step === 5) {
    return <Step6 machine={machine} />
  } else if (step === 6) {
    return <Result machine={machine} />
  } else return <Spinner />
}

export const MachineChecklistWizard = ({ onDone, machine }: {
  onDone: (id: string) => void
  machine: Machine
}) => {
  return <div className='machine-checklist-wizard'>

    {machine.machineType ? <h2><MachineName row={{
      internalNumber: machine.internalNumber,
      type: machine.machineType
    }} /></h2> : null}

    <WizardProvider<WizardData> initialData={cleanWizardData()} maxStep={maxStep}>
      <MachineChecklistWizardBody onDone={onDone} machine={machine} />
    </WizardProvider>
  </div>
}

// export const MachineChecklistWizardPopup = ({ onClose }: {
//   onClose: () => void
// }) => {
//   return <MachineChecklistWizard onDone={onClose} />
// }

export const MachineChecklistWizardPage = () => {
  const { services, session, translates } = useAppContext()
  const mid = useParams().mid
  const [machine, setMachine] = useState<Machine>()

  useEffect(() => {
    fetch(`/api/communal/machines/byid/${mid}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMachine(data)
    })
  }, [mid])

  if (!session || !translates || !machine) {
    return <Spinner />
  }

  return <MainPageLayout pageName='communal-dashboard-details' services={services} translates={translates} session={session} path={[...MachinePath({ session, translates, machine }), {
    title: translates.for(`machine.checklist.wizard.title`)
  }]}
    navbarLeft={<BackButton services={services} translates={translates} replaceUrl={`/communal/machine/${mid}`} />}>
    <MachineChecklistWizard onDone={() => {}}  machine={machine} />
  </MainPageLayout>
}
